import angular from 'angular';

let AdminDetailController = function ($filter, $mdDialog, $scope, $state, Toast, Admin, AdminDetail, Group) {
  let $ctrl = this;

  $ctrl.id = $state.params.id;
  $ctrl.admin;
  $ctrl.isPasswordVisible = false;


  angular.extend($ctrl, {
    clearImage,
    clearForm,
    handleSave,
    handleDelete,
    querySearchSquare,
    selectedSquareChange,
    querySearchUnit,
    selectedUnitChange
  });

  activate();

  async function activate() {
    clearForm();

    angular.element(document.querySelector('#fileInput')).on('change', handleFileSelect);

    $ctrl.uiState = 'LOADING';
    $ctrl.squares = [];
    $ctrl.units = [];

    await AdminDetail.getSquares().then(data => { $ctrl.squares = data; }).catch(err => { console.log(err) });
    await AdminDetail.getUnits().then(data => { $ctrl.units = data }).catch(err => { console.log(err) });

    loadDomainResources()
      .then(result => {
        $ctrl.access_groups = result[0];
        loadResource($ctrl.id);
      })
      .catch(err => {
        console.log('err:', err);
        $ctrl.uiState = 'ERROR';
      });
  }

  function clearImage() {
    angular.element(document.querySelector('#fileInput')).val(undefined);
    $ctrl.myImage = '';
    $ctrl.myCroppedImage = '';
    $ctrl.fileName = undefined;
    $ctrl.admin.image_uri = null;
  }

  function querySearchSquare(searchText) {
    searchText = searchText.toLowerCase();

    let results = _.filter($ctrl.squares, square => {
      return square.name.toLowerCase().indexOf(searchText) > -1;
    });

    return results;
  }

  function selectedSquareChange(square) {
    if (square) {
      $ctrl.squareSelected2 = square;
      $ctrl.searchTextUnit = null;
    }
  }

  function querySearchUnit(searchText) {
    searchText = searchText.toLowerCase();

    let results = _.filter($ctrl.units, unit => {
      return unit.address_neighborhood.toLowerCase().indexOf(searchText) > -1 || unit.name.toLowerCase().indexOf(searchText) > -1;
    });

    return results;
  }

  function selectedUnitChange(unit) {
    if (unit) {
      $ctrl.unitSelected2 = unit;
      $ctrl.searchTextSquare = null;
    }
  }

  function clearForm(form) {
    $ctrl.admin = {
      isActive: true
    };

    if (form) {
      form.email.$$element[0].value = '';
      form.$setPristine();
      form.$setUntouched();
    }

    $ctrl.myImage = '';
    $ctrl.myCroppedImage = '';
    $ctrl.fileName = undefined;
  }

  function handleDelete(admin, event) {
    let confirm = $mdDialog.confirm()
      .textContent($filter('translate')('admin-detail-delete-confirm-text'))
      .ariaLabel($filter('translate')('admin-detail-delete-confirm-text'))
      .targetEvent(event)
      .ok($filter('translate')('common-yes'))
      .cancel($filter('translate')('common-cancel'));

    $mdDialog.show(confirm)
      .then(() => {
        $ctrl.deleting = true;
        Admin
          .destroy(admin)
          .then(response => {
            Toast.success($filter('translate')('admin-detail-delete-success'));
            $ctrl.deleting = false;
            $state.go('admin.list')
          })
          .catch(err => {
            Toast.error($filter('translate')('common-server-error'));
            console.log('err:', err);
            $ctrl.deleting = false;
          });
      })
      .catch(() => {
      });
  }

  async function handleSave(form, admin) {
    if (!form.$valid) {
      Toast.error($filter('translate')('common-form-incomplete'));
      return;
    }

    admin.image_base64 = $ctrl.myCroppedImage;

    if ($ctrl.desactivated_at_changed) {
      admin.desactivated_at = $ctrl.admin.isActive ? null : moment();
    }

    $ctrl.saving = true;

    await Admin
      .save(admin)
      .then(async response => {
        Toast.success($filter('translate')('admin-detail-save-success'));
        if (response.access_group.special_rule === 'MANAGER') {
          if (!response.admin_user_regions.length) {
            await AdminDetail.setRegionInUser({
              region_id: $ctrl.squareSelected2.id,
              admin_user_id: response.id
            })
              .then(async () => { })
              .catch(async () => { });
          } else {
            await AdminDetail.updateRegionInUser({
              id: response.id,
              data: {
                region_id: $ctrl.squareSelected2.id
              }
            })
              .then(async () => { })
              .catch(async () => { });
          }
        }
        if (response.access_group.special_rule === 'COORDINATOR') {
          if (!response.admin_user_units.length) {
            await AdminDetail.setUnitInUser({
              unit_id: $ctrl.unitSelected2.id,
              admin_user_id: response.id
            })
              .then(async () => { })
              .catch(async () => { });
          } else {
            await AdminDetail.updateUnitInUser({
              id: response.id,
              data: {
                unit_id: $ctrl.unitSelected2.id
              }
            })
              .then(async () => { })
              .catch(async () => { });
          }
        }
        $ctrl.admin = response;
        $ctrl.saving = false;
        $state.go('admin.list');
      })
      .catch(err => {
        let defaultErrMsg = $filter('translate')('common-server-error');
        let fourONineMsg = $filter('translate')('admin-detail-409-error')
        let message = err.status == 409 ? fourONineMsg : defaultErrMsg;
        Toast.error(message);
        console.log('err:', err);
        $ctrl.saving = false;
      });
  }

  // Local functions

  function handleFileSelect(event) {
    let file = event.currentTarget.files[0];

    if (!file) {
      return;
    }

    let reader = new FileReader();
    reader.onload = function (event) {
      $ctrl.myImage = event.target.result;
      $scope.$apply();
      $ctrl.fileName = file.name;
      showCropDialog(event);
    };

    reader.readAsDataURL(file);
  }

  function showCropDialog(event) {
    $mdDialog.show({
      controller: DialogController,
      targetEvent: event,
      template:
        '<md-dialog aria-label="List dialog">' +
        '  <md-dialog-content>' +
        '    <ui-cropper' +
        '      image="myImage"' +
        '      area-type="circle"' +
        '      chargement="loadingText"' +
        '      result-image-size="{w: 200,h: 200}"' +
        '      result-image="myCroppedImage" canvas-scalemode="true">' +
        '    </ui-cropper>' +
        '  </md-dialog-content>' +
        '  <md-dialog-actions>' +
        '    <md-button ng-click="cancel()">' +
        '      Cancelar' +
        '    </md-button>' +
        '    <md-button ng-click="cropImage(myCroppedImage)" class="md-accent">' +
        '      Feito' +
        '    </md-button>' +
        '  </md-dialog-actions>' +
        '</md-dialog>',
      bindToController: true,
      parent: angular.element(document.body),
      clickOutsideToClose: true,
      fullscreen: false
    })
      .then(function (myCroppedImage) {
        $ctrl.myCroppedImage = myCroppedImage;
        $ctrl.myImage = '';
      }, function () {
        $scope.status = 'You cancelled the dialog.';
      });
  }

  function DialogController($scope, $mdDialog) {
    "ngInject";
    $scope.loadingText = 'Carregando';
    $scope.myImage = $ctrl.myImage;
    $scope.myCroppedImage = $ctrl.myCroppedImage;

    $scope.hide = function () {
      angular.element(document.querySelector('#fileInput')).val(undefined);
      $mdDialog.hide();
    };

    $scope.cancel = function () {
      angular.element(document.querySelector('#fileInput')).val(undefined);
      $mdDialog.cancel();
    };

    $scope.cropImage = function (myCroppedImage) {
      $mdDialog.hide(myCroppedImage);
    }
  }

  function loadResource(id) {
    if (id) {
      $ctrl.uiState = 'LOADING';

      Admin.show(id)
        .then(response => {
          response.isActive = !response.desactivated_at;
          $ctrl.admin = response;
          if ($ctrl.admin.admin_user_units.length) {
            $ctrl.unitSelected = $ctrl.units.find(el => el.id === $ctrl.admin.admin_user_units[0].unit_id)
          }
          if ($ctrl.admin.admin_user_regions.length) {
            $ctrl.squareSelected = $ctrl.squares.find(el => el.id === $ctrl.admin.admin_user_regions[0].region_id)
          }
          $ctrl.uiState = 'COMPLETE';
        })
        .catch(err => {
          console.log('err:', err);
          $ctrl.uiState = 'ERROR';
        });
    } else {
      $ctrl.uiState = 'COMPLETE';
      $scope.$apply();
    }
  }

  function loadDomainResources() {
    let promises = [];

    promises.push(Group.index());

    return Promise.all(promises);
  }

}

AdminDetailController.$inject = ['$filter', '$mdDialog', '$scope', '$state', 'Toast', 'Admin', 'AdminDetail', 'Group'];

export default AdminDetailController;



// WEBPACK FOOTER //
// ./client/app/components/admin/admin-detail.controller.js